import RacialTraitList from './RacialTraitList';

export default RacialTraitList;
export { RacialTraitList };
